"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TableList;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactVirtualizedAutoSizer = _interopRequireDefault(require("react-virtualized-auto-sizer"));
var _reactWindow = require("react-window");
var _logic = require("../../../utils/logic");
var _ReorderListItem = _interopRequireDefault(require("../../ReorderListItem"));
var _context = require("../context");
var _TableListBody = _interopRequireDefault(require("./TableListBody"));
var _TableListRow = _interopRequireDefault(require("./TableListRow"));
var _FormattedMessage;
/* eslint jsx-a11y/no-static-element-interactions: 0 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return (0, _extends2.default)({}, theme.mixins.table, {
    defaultBg: {},
    dense: {},
    dragButton: {
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    many: {},
    noResults: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      minHeight: 200
    },
    numberInput: (0, _extends2.default)({}, theme.mixins.table.numberInput, {
      padding: '5px !important'
    }),
    tableList: {
      '&$defaultBg': {
        '& $tableListRow': {
          '& $tableListRowExpandable': {
            borderTopColor: theme.palette.background.paper
          },
          '&:nth-of-type(odd)': {
            '& $tableListRowExpandable': {
              borderTopColor: theme.palette.background.default
            },
            backgroundColor: theme.palette.background.paper
          },
          backgroundColor: theme.palette.background.default
        }
      },
      '&$dense': {
        '& $tableListCell': {
          minHeight: 40,
          padding: theme.spacing(0, 2),
          [theme.breakpoints.down('md')]: {
            padding: theme.spacing(1, 2)
          }
        },
        '& $tableListCellItem': {
          '&$clear': {
            padding: '0 5px'
          },
          padding: '2px 5px',
          [theme.breakpoints.down('md')]: {
            minHeight: 45
          }
        },
        '& $tableListRowExpandable': {
          padding: theme.spacing(1, 2)
        },
        '&$noResults': {
          minHeight: theme.spacing(10)
        }
      },
      '&$many': {
        '& $tableListCell': {
          [theme.breakpoints.down('md')]: {
            display: 'block',
            padding: '5px 10px'
          }
        },
        '& $tableListCellItem': {
          [theme.breakpoints.down('md')]: {
            border: 'none',
            display: 'inline-block',
            maxWidth: '49%',
            minWidth: '49%',
            padding: 5
          }
        }
      },
      '&$virtualized': {
        '& $virtualizedList $tableListCell': {
          paddingRight: 0
        },
        borderBottom: 0
      },
      flexGrow: 1,
      width: '100%'
    },
    tableListCell: {
      '&$reorder': {
        padding: theme.spacing(0, 0, 0, 2)
      },
      alignItems: 'center',
      border: 0,
      borderRadius: 0,
      display: 'flex',
      flex: '1 1 auto',
      fontWeight: 400,
      justifyContent: 'flex-start',
      minHeight: 50,
      padding: "5px ".concat(theme.spacing(2)),
      userSelect: 'auto'
    },
    tableListCellItem: {
      flex: '1 1 100%',
      minWidth: 0,
      overflowWrap: 'anywhere',
      padding: 5,
      verticalAlign: 'top'
    },
    tableListCellItemLabel: {
      display: 'block',
      fontSize: 12,
      fontWeight: 'bold',
      lineHeight: theme.spacing(1.5),
      [theme.breakpoints.up('md')]: {
        display: 'none'
      }
    },
    tableListRow: {
      '& $tableListRowExpandable': {
        borderTopColor: theme.palette.background.default,
        borderTopStyle: 'solid',
        borderTopWidth: 1
      },
      '&$virtualized': {
        borderBottom: "1px solid ".concat(theme.palette.background.default)
      },
      '&:not($virtualized):nth-of-type(odd)': {
        '& $tableListRowExpandable': {
          borderTopColor: theme.palette.background.paper
        },
        backgroundColor: theme.palette.background.default
      },
      backgroundColor: theme.palette.background.paper
    },
    tableListRowExpandable: {
      padding: theme.spacing(2, 3),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(1, 2)
      }
    },
    tableListRowItem: {
      alignItems: 'center',
      display: 'flex',
      width: '100%'
    },
    tableListRowItemAction: {
      alignItems: 'center',
      display: 'flex',
      flex: "0 0 ".concat(theme.spacing(8)),
      justifyContent: 'flex-end',
      paddingRight: theme.spacing(2)
    },
    tableListRowText: {
      fontSize: 13,
      fontWeight: 500
    },
    textInput: {
      padding: '5px !important'
    },
    virtualized: {},
    virtualizedList: {
      '&::-webkit-scrollbar': {
        height: 0,
        width: 0
      }
    }
  });
});
function TableList(_ref) {
  var id = _ref.id,
    virtualized = _ref.virtualized;
  var _useContext = (0, _react.useContext)(_context.TableListContext),
    _useContext$classes = _useContext.classes,
    classes = _useContext$classes === void 0 ? {
      tableList: null,
      tableListCell: null,
      tableListCellItem: null,
      tableListCellItemLabel: null,
      tableListRow: null,
      tableListRowExpandable: null,
      tableListRowItem: null
    } : _useContext$classes,
    dense = _useContext.dense,
    _useContext$fields = _useContext.fields,
    fields = _useContext$fields === void 0 ? [] : _useContext$fields,
    getTableRowItemKey = _useContext.getTableRowItemKey,
    headerBgColorDefault = _useContext.headerBgColorDefault,
    _useContext$itemKeyFi = _useContext.itemKeyField,
    itemKeyField = _useContext$itemKeyFi === void 0 ? 'id' : _useContext$itemKeyFi,
    _useContext$items = _useContext.items,
    items = _useContext$items === void 0 ? [] : _useContext$items,
    reorderable = _useContext.reorderable,
    disableHover = _useContext.disableHover;
  var virtualizedListRef = (0, _react.useRef)(null);
  var styles = useStyles();
  var sm = (0, _material.useMediaQuery)(function (_ref2) {
    var breakpoints = _ref2.breakpoints;
    return breakpoints.down('sm');
  });
  (0, _react.useEffect)(function () {
    if (virtualizedListRef != null && virtualizedListRef.current) {
      virtualizedListRef.current.resetAfterIndex(0);
    }
  }, [virtualizedListRef, sm]);
  if (items.length === 0) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.tableList, styles.noResults, {
        [styles.dense]: dense
      }),
      id: id
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      id: "".concat(id, "NoResults"),
      variant: dense ? 'body2' : 'body1'
    }, _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "No results to show",
      id: "table.noResults"
    }))));
  }
  var many = fields.length > 2;
  var getTableRowItemSize = function getTableRowItemSize() {
    var length = 1;
    var size = 50;
    var padding = 0;
    if (dense) {
      size = 40;
    }
    if (sm) {
      length = Math.round(fields.length / 2);
      size = 45;
      padding = dense ? 16 : 10;
    }
    return length * size + padding;
  };
  return /*#__PURE__*/_react.default.createElement(_TableListBody.default, {
    className: (0, _classnames.default)(styles.tableList, classes.tableList, {
      [styles.dense]: dense,
      [styles.defaultBg]: headerBgColorDefault,
      [styles.many]: many,
      [styles.virtualized]: virtualized
    }),
    id: id,
    reorderable: reorderable
  }, virtualized ? /*#__PURE__*/_react.default.createElement(_reactVirtualizedAutoSizer.default, null, function (_ref3) {
    var height = _ref3.height,
      width = _ref3.width;
    return /*#__PURE__*/_react.default.createElement(_reactWindow.VariableSizeList, {
      ref: virtualizedListRef,
      className: styles.virtualizedList,
      height: height,
      itemCount: items.length,
      itemData: items,
      itemKey: function itemKey(index, data) {
        return getTableRowItemKey ? getTableRowItemKey(index, data) : data[index].id;
      },
      itemSize: getTableRowItemSize,
      width: width
    }, function (_ref4) {
      var index = _ref4.index,
        data = _ref4.data,
        style = _ref4.style;
      return /*#__PURE__*/_react.default.createElement(_TableListRow.default, {
        classes: styles,
        className: (0, _classnames.default)(styles.tableListRow, (0, _logic.execIfFunc)(classes.tableListRow, data[index]), virtualized && styles.virtualized),
        disableHover: disableHover,
        i: index,
        id: "".concat(id).concat(index),
        item: data[index],
        style: style
      });
    });
  }) : items.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(_TableListRow.default, {
      key: item[itemKeyField],
      classes: styles,
      className: (0, _classnames.default)(styles.tableListRow, (0, _logic.execIfFunc)(classes.tableListRow, item)),
      component: reorderable ? _ReorderListItem.default : 'div',
      disableHover: disableHover,
      i: i,
      id: "".concat(id).concat(i),
      item: item,
      items: items
    });
  }));
}